const DEFAULT_LEVERAGE_MARKS = [
	1, 2, 3, 5, 10, 20, 25, 50, 75, 100, 125, 150, 200,
];

export const DEFAULT_LEVERAGE_VALUE = 3;

export function buildLeverageMarks(maxLeverage: number): number[] {
	const marks = DEFAULT_LEVERAGE_MARKS.filter((m) => m <= maxLeverage);
	if (marks[marks.length - 1] !== maxLeverage) {
		marks.push(maxLeverage);
	}
	return marks;
}

export const sliderSteps = [0, 25, 50, 75, 100];

export const orderTypeOptions = [
	{ value: "Limit order", labelKey: "order.type.limit" },
	{ value: "Market order", labelKey: "order.type.market" },
	{ value: "Stop limit", labelKey: "order.type.stop-limit" },
	{ value: "Stop market", labelKey: "order.type.stop-market" },
	{ value: "Take profit limit", labelKey: "order.type.tp-limit" },
	{ value: "Take profit market", labelKey: "order.type.tp-market" },
	{ value: "TWAP", labelKey: "order.type.twap" },
] as const;

export const marginModeOptions = [
	{
		value: "Cross",
		labelKey: "margin.cross-label",
		descriptionKey: "margin.cross-description",
	},
	{
		value: "Isolated",
		labelKey: "margin.isolated-label",
		descriptionKey: "margin.isolated-description",
	},
] as const;

export const orderSideOptions = [
	{ key: "buy", labelKey: "order.side.buy" },
	{ key: "sell", labelKey: "order.side.sell" },
] as const;

export const timeInForceOptions = ["GTC", "IOC"] as const;

export type MarginMode = (typeof marginModeOptions)[number]["value"];
export type OrderSide = (typeof orderSideOptions)[number]["key"];
export type OrderType = (typeof orderTypeOptions)[number]["value"];
export type TimeInForce = (typeof timeInForceOptions)[number];

const triggerOrderTypes: OrderType[] = [
	"Stop limit",
	"Stop market",
	"Take profit limit",
	"Take profit market",
];

const marketOrderTypes: OrderType[] = [
	"Market order",
	"Stop market",
	"Take profit market",
];

export function isTriggerOrderType(type: OrderType) {
	return triggerOrderTypes.includes(type);
}

export function isMarketOrderType(type: OrderType) {
	return marketOrderTypes.includes(type);
}

export function isTwapOrderType(type: OrderType) {
	return type === "TWAP";
}

export function needsLimitPrice(type: OrderType) {
	return !isMarketOrderType(type) && !isTwapOrderType(type);
}
